export function sumCalculatePrice(data) {
  let total = 0;
  for (const item of data) {
    if (
      item.type === "price" ||
      item.type === "fees" ||
      item.type === "overtime_price" ||
      item.type === "out-of-town" ||
      item.type === "additional" ||
      item.type === "out-of-island" ||
      item.type === "addtional-all-in-one"
    ) {
      total += item.price || 0;
    }
  }
  return total;
}
